// source: witbooking/backoffice/occupation/v1/occupation_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetOccupationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.GetOccupationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.Occupation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetOccupationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.GetOccupationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetOccupationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.GetOccupationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.displayName = 'proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.displayName = 'proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.Occupation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.occupation.v1.Occupation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.Occupation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.Occupation.displayName = 'proto.witbooking.backoffice.occupation.v1.Occupation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.occupation.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.occupation.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.occupation.v1.Translation.displayName = 'proto.witbooking.backoffice.occupation.v1.Translation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest;
  return proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configurationsList: jspb.Message.toObjectList(msg.getConfigurationsList(),
    proto.witbooking.backoffice.occupation.v1.Occupation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse;
  return proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.addConfigurations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Occupation configurations = 1;
 * @return {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.getConfigurationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} value
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse} returns this
*/
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.setConfigurationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.addConfigurations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.occupation.v1.Occupation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse} returns this
 */
proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.prototype.clearConfigurationsList = function() {
  return this.setConfigurationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetOccupationRequest;
  return proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupation: (f = msg.getOccupation()) && proto.witbooking.backoffice.occupation.v1.Occupation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetOccupationResponse;
  return proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.setOccupation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Occupation occupation = 1;
 * @return {?proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.getOccupation = function() {
  return /** @type{?proto.witbooking.backoffice.occupation.v1.Occupation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.occupation.v1.Occupation|undefined} value
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse} returns this
*/
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.setOccupation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse} returns this
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.clearOccupation = function() {
  return this.setOccupation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.prototype.hasOccupation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest;
  return proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupationsList: jspb.Message.toObjectList(msg.getOccupationsList(),
    proto.witbooking.backoffice.occupation.v1.Occupation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse;
  return proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.addOccupations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Occupation occupations = 1;
 * @return {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.getOccupationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} value
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse} returns this
*/
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.setOccupationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.addOccupations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.occupation.v1.Occupation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse} returns this
 */
proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.prototype.clearOccupationsList = function() {
  return this.setOccupationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupation: (f = msg.getOccupation()) && proto.witbooking.backoffice.occupation.v1.Occupation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest;
  return proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.setOccupation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Occupation occupation = 1;
 * @return {?proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.getOccupation = function() {
  return /** @type{?proto.witbooking.backoffice.occupation.v1.Occupation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.occupation.v1.Occupation|undefined} value
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} returns this
*/
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.setOccupation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.clearOccupation = function() {
  return this.setOccupation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest.prototype.hasOccupation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupation: (f = msg.getOccupation()) && proto.witbooking.backoffice.occupation.v1.Occupation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse;
  return proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.setOccupation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Occupation occupation = 1;
 * @return {?proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.getOccupation = function() {
  return /** @type{?proto.witbooking.backoffice.occupation.v1.Occupation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.occupation.v1.Occupation|undefined} value
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse} returns this
*/
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.setOccupation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse} returns this
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.clearOccupation = function() {
  return this.setOccupation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.prototype.hasOccupation = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupationsList: jspb.Message.toObjectList(msg.getOccupationsList(),
    proto.witbooking.backoffice.occupation.v1.Occupation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest;
  return proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.addOccupations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Occupation occupations = 1;
 * @return {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.getOccupationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} value
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} returns this
*/
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.setOccupationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.addOccupations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.occupation.v1.Occupation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest.prototype.clearOccupationsList = function() {
  return this.setOccupationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupationsList: jspb.Message.toObjectList(msg.getOccupationsList(),
    proto.witbooking.backoffice.occupation.v1.Occupation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse;
  return proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.addOccupations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Occupation occupations = 1;
 * @return {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.getOccupationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.occupation.v1.Occupation>} value
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse} returns this
*/
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.setOccupationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.addOccupations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.occupation.v1.Occupation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse} returns this
 */
proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.prototype.clearOccupationsList = function() {
  return this.setOccupationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    occupation: (f = msg.getOccupation()) && proto.witbooking.backoffice.occupation.v1.Occupation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest;
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.occupation.v1.Occupation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader);
      msg.setOccupation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOccupation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Occupation occupation = 1;
 * @return {?proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.getOccupation = function() {
  return /** @type{?proto.witbooking.backoffice.occupation.v1.Occupation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.occupation.v1.Occupation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.occupation.v1.Occupation|undefined} value
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} returns this
*/
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.setOccupation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.clearOccupation = function() {
  return this.setOccupation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest.prototype.hasOccupation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse;
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest;
  return proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse;
  return proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configurationsMap: (f = msg.getConfigurationsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest;
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getConfigurationsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigurationsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> configurations = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.prototype.getConfigurationsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} returns this
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest.prototype.clearConfigurationsMap = function() {
  this.getConfigurationsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse;
  return proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.occupation.v1.Occupation.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.Occupation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.Occupation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    seniors: jspb.Message.getFieldWithDefault(msg, 3, 0),
    adults: jspb.Message.getFieldWithDefault(msg, 4, 0),
    juniors: jspb.Message.getFieldWithDefault(msg, 5, 0),
    children: jspb.Message.getFieldWithDefault(msg, 6, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 7, 0),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.occupation.v1.Translation.toObject, includeInstance),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    pax: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.Occupation;
  return proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeniors(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJuniors(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.occupation.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.occupation.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.Occupation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.Occupation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeniors();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getJuniors();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.witbooking.backoffice.occupation.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getPax();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 seniors = 3;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getSeniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setSeniors = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 adults = 4;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 juniors = 5;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getJuniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setJuniors = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 children = 6;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 babies = 7;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated Translation translations = 8;
 * @return {!Array<!proto.witbooking.backoffice.occupation.v1.Translation>}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.occupation.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.occupation.v1.Translation, 8));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.occupation.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
*/
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.witbooking.backoffice.occupation.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional bool in_use = 9;
 * @return {boolean}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 pax = 10;
 * @return {number}
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.getPax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Occupation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Occupation.prototype.setPax = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.occupation.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.occupation.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation}
 */
proto.witbooking.backoffice.occupation.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.occupation.v1.Translation;
  return proto.witbooking.backoffice.occupation.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.occupation.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation}
 */
proto.witbooking.backoffice.occupation.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.occupation.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.occupation.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.occupation.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.occupation.v1.Translation} returns this
 */
proto.witbooking.backoffice.occupation.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.occupation.v1);
